import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const CarVan: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m510 735c-33.08 0-60-26.92-60-60s26.92-60 60-60 60 26.92 60 60-26.92 60-60 60zm0-90c-16.54 0-30 13.46-30 30s13.46 30 30 30 30-13.46 30-30-13.46-30-30-30z' />
    <path d='m150 735c-33.08 0-60-26.92-60-60s26.92-60 60-60 60 26.92 60 60-26.92 60-60 60zm0-90c-16.54 0-30 13.46-30 30s13.46 30 30 30 30-13.46 30-30-13.46-30-30-30z' />
    <path d='m555 660h60v30h-60z' />
    <path d='m630 690h-30v-120h-53.71l-47.04-82.33c-7.99-13.99-22.96-22.67-39.07-22.67h-198.75l-100 105h-86.43c-8.27 0-15 6.73-15 15v75h45v30h-75v-105c0-24.81 20.19-45 45-45h73.57l100-105h211.61c26.85 0 51.8 14.48 65.12 37.79l38.41 67.21h66.29z' />
    <path d='m190 660h280v30h-280z' />
    <path d='m510 570h-360s0-30 0-30h330c16.57 0 30 13.43 30 30z' />
    <path d='m360 465h30v105h-30z' />
    <path d='m330 40.67h30v134.33h-30z' />
    <path d='m630 375c-33.08 0-60-26.92-60-60s26.92-60 60-60 60 26.92 60 60-26.92 60-60 60zm0-90c-16.54 0-30 13.46-30 30s13.46 30 30 30 30-13.46 30-30-13.46-30-30-30z' />
    <path d='m240 375c-33.08 0-60-26.92-60-60s26.92-60 60-60 60 26.92 60 60-26.92 60-60 60zm0-90c-16.54 0-30 13.46-30 30s13.46 30 30 30 30-13.46 30-30-13.46-30-30-30z' />
    <path d='m280 300h305v30h-305z' />
    <path d='m140 170h195v30h-195z' />
    <path d='m330 270v-120s30 0 30 0v90c0 16.57-13.43 30-30 30z' />
    <path d='m750 330h-65v-30h35v-195c0-24.81-20.19-45-45-45h-446.89l-70.78 108.25c-4.8 7.34-7.34 15.86-7.34 24.63v107.12h45v30h-75v-137.12c0-14.62 4.23-28.81 12.23-41.04l79.67-121.84h463.11c41.35 0 75 33.64 75 75z' />
  </IconBase>
));

CarVan.displayName = 'CarVan';

export default CarVan;
